
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("7Y0pd", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $g9yj0 = parcelRequire("g9yj0");

var $7iHUq = parcelRequire("7iHUq");

var $fWKP5 = parcelRequire("fWKP5");

var $4QIXk = parcelRequire("4QIXk");

var $1PSAp = parcelRequire("1PSAp");

var $koAZ4 = parcelRequire("koAZ4");
(0, $fWKP5.provideHealthcheck)();
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $5027c3f96b785100$var$container = document.createElement('div');
$5027c3f96b785100$var$container.id = 'heartbeat';
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
document.body && document.body.appendChild($5027c3f96b785100$var$container);
(0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QIXk.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextSubscriber), null, ({ tenantContext: { isAnonymous: isAnonymous } })=>!isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
        id: "heartbeat"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g9yj0.default), null))))), $5027c3f96b785100$var$container);

});
parcelRegister("g9yj0", function(module, exports) {
$parcel$export(module.exports, "default", () => $840ae29347e169f0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bZMH0 = parcelRequire("bZMH0");
const $840ae29347e169f0$var$HeartbeatNew = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        const heartbeatService = (0, $bZMH0.getInstance)();
        return ()=>heartbeatService.cleanup();
    }, []);
    return null;
};
var $840ae29347e169f0$export$2e2bcd8739ae039 = $840ae29347e169f0$var$HeartbeatNew;

});

parcelRegister("fWKP5", function(module, exports) {
$parcel$export(module.exports, "provideHealthcheck", () => $536332286f9d55b5$export$90dcee7ddb8a0c0c);
const $536332286f9d55b5$var$globalObj = window || $parcel$global;
const $536332286f9d55b5$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
const $536332286f9d55b5$export$90dcee7ddb8a0c0c = (healthcheck = $536332286f9d55b5$var$defaultHealthcheck)=>{
    $536332286f9d55b5$var$globalObj.performHealthcheck = healthcheck;
};

});



//# sourceMappingURL=async-heartbeat.c42761a4.js.map
